function AggregateRating(data) {
    let aggregate = data || {};
    this.ratingCount = aggregate.ratingCount;
    this.ratingValue = aggregate.ratingValue;
}
module.exports = AggregateRating;